<template>
    <div>
        <div class="card card-frame col-md-12">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col">
                        <strong>TICKET ROMANA</strong>
                    </div>
                    <div class="col text-right">

                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-blue">
                                <tr>
                                    <th class="text-center">PATENTE</th>
                                    <th class="text-center">N° TICKET</th>
                                    <th class="text-center">CICLO</th>
                                    <th class="text-center">CHOFER</th>
                                    <!-- <th>EMPRESA</th> -->
                                </tr>
                            </thead>
                            <tr>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.patente : '' }}</td>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.codigo_ticket : '' }}</td>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.ciclo_ticket ==
                                    2 ? 'Despacho' : 'Recepción' : '' }}</td>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.conductor.nombre_completo : ''
                                }}
                                </td>
                                <!-- <td>{{ticket_etruck.CliRazSoc}}</td> -->
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">

                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO BRUTO</th>
                                </tr>
                                <tr>
                                    <th>FECHA PESO BRUTO</th>
                                    <td>{{ ticket_romana ? ticket_romana.fecha_hora_bruto : null | fecha_hora }}</td>

                                </tr>
                                <tr>
                                    <th>PESO TOTAL BRUTO</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_total_bruto : '' }}</td>
                                </tr>
                                <tr>
                                    <th>PESO BRUTO SIN/ENV</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_vehiculo_bruto : '' }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>

                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO TARA</th>
                                </tr>
                                <tr>
                                    <th>FECHA TARA</th>
                                    <td>{{ ticket_romana ? ticket_romana.fecha_hora_tara : null | fecha_hora }}</td>

                                </tr>
                                <tr>
                                    <th>PESO TOTAL TARA</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_total_tara : '' }}</td>
                                </tr>
                                <tr>
                                    <th>PESO TARA SIN/ENV</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_vehiculo_tara : '' }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>



                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO NETO</th>
                                </tr>
                                <tr>
                                    <th>PESO NETO INFORMADO</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_informado : '' }}</td>

                                </tr>
                                <tr>
                                    <th>PESO NETO</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_comercial_neto : '' }}</td>
                                </tr>
                                <tr>
                                    <th>PESO NETO CORREGIDO</th>
                                    <td>{{ ticket_romana ? ticket_romana.peso_neto_corregido_guias : '' }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>

                <div class="row mb-2" v-if="folio_transbordador != null">
                    <div class="col-md-12 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-orange">
                                <tr>
                                    <th class="text-center">Folio 1</th>
                                    <th class="text-center">Tipo Transporte</th>
                                    <th class="text-center border-right-white">Empresa Transporte</th>
                                    <th class="text-center">Folio 2</th>
                                    <th class="text-center">Tipo transporte</th>
                                    <th class="text-center">Empresa Transporte</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


            </div>
        </div>

        <!-- guias -->
        <div class="guia-card" v-for="(g, idx_guia) in guias_romana" :key="idx_guia">

            <!-- HEADER -->
            <div class="guia-header">
                <div class="guia-title">
                    GUÍA {{ g.numero_guia }}

                    <i v-if="verificar_permiso('ROMANA_DETALLE_TICKET_ELIMINAR_GUIA')" class="fas fa-trash-alt delete-icon" @click="eliminarGuia(g.id, g.numero_guia)"
                        title="Eliminar guía"></i>
                </div>

                <div class="guia-actions">
                    <button v-if="g.historicas && g.historicas.length" class="btn-modern" data-toggle="modal"
                        :data-target="`#modal_g_historicas${g.numero_guia}`">
                        Históricas
                    </button>

                    <button class="btn-danger" @click="verArchivo(`${api_public}/guias/${g.url_guia}`)">
                        PDF
                    </button>
                </div>
            </div>

            <!-- GRID INFO -->
            <div class="guia-grid">

                <div class="item">
                    <label>Fecha</label>
                    <span>{{ g.fecha | fecha_hora }}</span>
                </div>

                <div class="item highlight success" v-if="g.numero_guia_origen">
                    <label>Guía Origen</label>
                    <span>{{ g.numero_guia_origen }}</span>
                </div>

                <div class="item">
                    <label>Empresa</label>
                    <span>{{ g.empresa.nombre }}</span>
                </div>

                <div class="item">
                    <label>Sucursal</label>
                    <span>{{ g.sucursal.nombre }}</span>
                </div>

                <div class="item">
                    <label>Bins</label>
                    <span>
                        {{ g.cantidad_bins }}
                        <i v-if="g.cantidad_bins > 0" class="fas fa-box-open info-icon" :title="g.detalle_bins"></i>
                    </span>
                </div>

                <div class="item highlight">
                    <label>Peso Informado</label>
                    <span>{{ g.peso_informado }}</span>
                </div>

                <div class="item highlight success">
                    <label>Peso Recibido</label>
                    <span>{{ g.peso_real }}</span>
                </div>

                <div class="item warning" v-if="g.restricciones_texto">
                    <label>Restricción</label>
                    <span>{{ g.restricciones_texto }}</span>
                </div>

            </div>

            <!-- DISTRIBUCION -->
            <div v-if="ticket_romana.ciclo_ticket == 1" class="guia-section">
                <div class="section-title">Distribución</div>

                <div class="distribucion-list">

                    <div class="distribucion-row" v-for="(dist, idx_dist) in g.distribuciones" :key="idx_dist">

                        <div class="col">
                            <label>Destino</label>
                            <span>{{ dist.destino_texto }}</span>
                        </div>

                        <div class="col">
                            <label>Materia Prima</label>
                            <span>{{ dist.mp }}</span>
                        </div>

                        <div class="col">
                            <label>Especie</label>
                            <span>{{ dist.esp }}</span>
                        </div>

                        <div class="col peso">
                            <label>Peso</label>
                            <span>{{ dist.peso_real }}</span>
                        </div>

                    </div>

                </div>
            </div>

            <!-- DATOS ADICIONALES -->
            <div v-if="ticket_romana.ciclo_ticket == 1" class="guia-section">
                <div class="section-title">Datos adicionales</div>

                <div class="data-list">
                    <div class="data-item" v-for="(dato, idx_dato) in g.guias_info_adicionales" :key="idx_dato">

                        <span>{{ dato.dato_adicional.nombre }}</span>

                        <span v-if="dato.tipo_dato == '1' || dato.tipo_dato == '2'">
                            {{ dato.valor_campo }}
                        </span>

                        <button v-if="dato.tipo_dato == '3'" class="btn-modern"
                            @click="verArchivo(`${api_public}/guias/archivos_adicionales/${dato.valor_campo}`)">
                            Ver archivo
                        </button>
                    </div>
                </div>
            </div>

        </div>

        <!-- <pre>{{guias_romana}}</pre> -->
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Swal from "sweetalert2";
export default {
    data: () => ({
        ticket_romana: null,
        guias_romana: [],
        folio_transbordador: null,
        detallesVisibles: {},
    }),
    mounted() {
        //console.log('id',this.$route.params.id);
        this.cargarTicket();
    },
    methods: {
        async cargarTicket() {
            await this.axios.get(`${this.api}/tickets/${this.$route.params.id}`, this.cabeceras_json).then((res) => {
                //console.log('res',res.data);
                this.ticket_romana = res.data.data;
                this.guias_romana = res.data.data.guias_romana;
            }).catch((e) => {
                //console.log(e);
            });
        },
        verArchivo(ruta) {
            window.open(ruta, '_blank');
        },
        async eliminarGuia(id, numero) {
            const result = await Swal.fire({
                title: `¿Estás seguro de querer eliminar la guía número: ${numero}, con id: ${id}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#5e72e4",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar"
            });

            if (!result.isConfirmed) {
                return;
            }

            this.axios.delete(`${this.api}/guias/${id}`, this.cabeceras_json).then(res => {
                console.log(res);

                Swal.fire({
                    icon: "success",
                    title: res.data.mensaje,
                    confirmButtonColor: "#2dce89"
                });

                this.cargarTicket();
            }).catch(error => {
                console.error(error);

                Swal.fire({
                    icon: "error",
                    title: "¡Error!",
                    text: error.response?.data?.mensaje || "Ha ocurrido un error al eliminar guía",
                    confirmButtonColor: "#2dce89"
                });
            })
        },
        async eliminarGuiaReemplazada(id, numero) {
            const result = await Swal.fire({
                title: `¿Estás seguro de querer eliminar la guía número: ${numero}, con id: ${id}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#5e72e4",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar"
            });

            if (!result.isConfirmed) {
                return;
            }

            this.axios.delete(`${this.api}/guias/${id}/historico`, this.cabeceras_json).then(res => {
                console.log(res);

                Swal.fire({
                    icon: "success",
                    title: res.data.mensaje,
                    confirmButtonColor: "#2dce89"
                });

                this.cargarTicket();
            }).catch(error => {
                console.error(error);

                Swal.fire({
                    icon: "error",
                    title: "¡Error!",
                    text: error.response?.data?.mensaje || "Ha ocurrido un error al eliminar guía",
                    confirmButtonColor: "#2dce89"
                });
            })
        },

        toggleDetalles(numeroGuia) {
            this.$set(this.detallesVisibles, numeroGuia, !this.detallesVisibles[numeroGuia]);
        },
    },
    computed: {
        ...mapState(['api', 'api_public', 'cabeceras_json'])
    }
}
</script>
<style>
.thead-blue {
    background-color: #172b4d;
    color: #fff;
}

.guia-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    transition: 0.2s;
}

.guia-card:hover {
    transform: translateY(-2px);
}

.guia-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.guia-title {
    font-weight: bold;
    font-size: 1.2rem;
    color: #0d1f45;
}

.guia-actions {
    display: flex;
    gap: 0.5rem;
}

.guia-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;
}

.item {
    background: #f8fafc;
    padding: 0.7rem;
    border-radius: 10px;
}

.item label {
    font-size: 0.7rem;
    color: #6b7280;
    display: block;
}

.item span {
    font-weight: 600;
}

.item.highlight {
    background: #eef2ff;
}

.item.success {
    background: #e6fffa;
}

.item.warning {
    background: #fff4e5;
    color: #b45309;
}

.guia-section {
    margin-top: 1rem;
}

.section-title {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.chip {
    background: #e0f2fe;
    padding: 0.5rem 0.8rem;
    border-radius: 999px;
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
}

.data-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.data-item {
    display: flex;
    justify-content: space-between;
    background: #f9fafb;
    padding: 0.6rem;
    border-radius: 8px;
}

.btn-modern {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 0.4rem 0.8rem;
    border-radius: 8px;
    cursor: pointer;
}

.btn-danger {
    background: #ef4444;
    color: white;
    border: none;
    padding: 0.4rem 0.8rem;
    border-radius: 8px;
}

.info-icon {
    color: #2563eb;
    margin-left: 4px;
}
.guia-title {
    display: flex;
    align-items: center;
    gap: 6px;
}

.delete-icon {
    color: #dc2626;
    cursor: pointer;
    font-size: 16px;
    transition: transform 0.2s ease;
}

.delete-icon:hover {
    transform: scale(1.15);
}
</style>

<style scoped>
.btn-delete {
    padding: 0.4rem 0.5rem;
    display: flex;
    justify-content: center;
    background-color: red;
    border-radius: 0.7rem;
    color: white;
    border: white;
    box-shadow: 1px 1px 3px 1px #c9c8c8;
    transition: background-color 0.3s ease;
}

.btn-delete:hover {
    background-color: rgb(210, 0, 0);
}

.btn-delete:focus,
.btn-delete:focus-visible {
    outline: 0;
}

.guia-reemplazada-container {
    position: relative;
    border: 1px solid #e9ecef;
    border-radius: 1rem;
    padding: 1.2rem 0.4rem;
    margin-bottom: 1rem;
}

.guia-reemplazada-title {
    position: absolute;
    top: 0;
    left: 2rem;
    transform: translateY(-50%);
    font-size: 1rem;
    padding: 0 0.5rem;
    background-color: white;
}

.guia-reemplazada-title-right {
    left: auto;
    right: 2em;
}

.distribucion-list {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.distribucion-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
    border-radius: 10px;
    padding: 0.8rem 1rem;
    border: 1px solid #e2e8f0;
    transition: 0.2s;
}

.distribucion-row:hover {
    background: #eef2ff;
}

.col {
    display: flex;
    flex-direction: column;
    min-width: 120px;
}

.col label {
    font-size: 0.65rem;
    color: #64748b;
}

.col span {
    font-weight: 600;
    color: #0f172a;
}

/* Peso destacado */
.col.peso span {
    color: #0d9488;
    font-size: 1rem;
}
</style>